import styled from 'styled-components';
import { variant } from 'styled-system';

import { pxToRem } from '../theme/utils/pxToRem';

const pointVariant = (item) => {
  return variant({
    variants: {
      line: {
        ':after': {
          height: pxToRem(1),
          width: item.selected ? '100%' : 0,
          background: item.selected ? '#3564fd' : '',
          position: 'absolute',
          bottom: 0,
          left: 0,
          zIndex: 1
        }
      },
      point: {
        ':after': {
          height: pxToRem(8),
          width: pxToRem(8),
          borderRadius: '50%',
          background: item.selected ? '#3564fd' : '',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          margin: 'auto',
          right: 'auto',
          zIndex: 1
        }
      }
    }
  });
};

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledArrowButton = styled.button<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 1 48px;
  padding: 0 0.5rem;
  border: none;
  background-color: transparent;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const StyledTabsContainer = styled.div<{ variant: 'line' | 'point' }>`
  position: relative;
  width: auto;
  height: 48px;
  min-width: 0;
  box-sizing: border-box;
  flex: 1 1 auto;

  :after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #bdbdbd;
    width: 100%;
    display: ${({ variant }) => (variant === 'line' ? 'block' : 'none')};
    z-index: -1;
  }
`;

export const StyledTabsInnerContainer = styled.div.attrs({
  className: 'keen-slider'
})`
  min-width: 100%;
  transition: transform 0.3s ease-in;
`;

export const StyledTab = styled.button.attrs<HTMLButtonElement>({
  className: 'keen-slider__slide'
})<{
  selected?: boolean;
  variant?: 'line' | 'point';
}>`
  justify-content: center;
  position: relative;
  flex-grow: 1;
  padding: ${({ variant: variantPointer, selected }) =>
    variantPointer === 'point' && selected
      ? '11px 20px 19px'
      : '15px 20px 17px'};
  font-size: 14px;
  line-height: 1.29;
  text-align: center;
  color: ${({ selected, variant: variantPointer }) =>
    selected && variantPointer === 'line' ? '#3564fd' : '#565656'};
  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: ${({ selected, variant }) =>
    selected && variant === 'line' ? 600 : 'normal'};
  height: 48px;
  transition: padding 0.3s ease-in;
  white-space: nowrap;

  background-image: ${({ selected, variant: variantPointer }) =>
    selected && variantPointer === 'line'
      ? 'linear-gradient(90deg, #3564fd 80%, rgba(0, 0, 0, 0) 99%)'
      : 'linear-gradient(90deg, #565656 80%, rgba(0, 0, 0, 0) 99%)'};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: ${({ selected, variant: variantPointer }) =>
    selected && variantPointer === 'line' ? '#3564fd' : '#565656'};

  :after {
    content: '';
  }

  ${pointVariant}
`;

export const StyledTabsPanelsContainer = styled.div.attrs({
  className: 'keen-slider'
})`
  margin: 12px auto;
`;

export const StyledTabPanel = styled.div.attrs<HTMLDivElement>({
  className: 'keen-slider__slide'
})``;
